var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubSystm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.253,
    height: 18.253,
    viewBox: "0 0 18.253 18.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_data",
    "data-name": "vuesax/bold/data",
    transform: "translate(206.253 -620) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data",
    transform: "translate(620 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18.253V18.253H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.422,1.711A1.711,1.711,0,1,1,1.711,0,1.711,1.711,0,0,1,3.422,1.711Z",
    transform: "translate(13.499 7.415)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.422,1.711A1.711,1.711,0,1,1,1.711,0,1.711,1.711,0,0,1,3.422,1.711Z",
    transform: "translate(13.499 1.331)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.422,1.711A1.711,1.711,0,1,1,1.711,0,1.711,1.711,0,0,1,3.422,1.711Z",
    transform: "translate(13.499 13.499)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3.422,1.711A1.711,1.711,0,1,1,1.711,0,1.711,1.711,0,0,1,3.422,1.711Z",
    transform: "translate(1.331 7.415)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M11.218,7.225a.57.57,0,0,0,0-1.141H5.7V2.852c0-1.2.51-1.711,1.711-1.711h3.8a.575.575,0,0,0,.57-.57.575.575,0,0,0-.57-.57h-3.8A2.571,2.571,0,0,0,4.563,2.852V6.084H.57a.57.57,0,0,0,0,1.141H4.563v3.232a2.571,2.571,0,0,0,2.852,2.852h3.8a.57.57,0,1,0,0-1.141h-3.8c-1.2,0-1.711-.51-1.711-1.711V7.225Z",
    transform: "translate(3.232 2.472)",
    fill: "#1383d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubSystm);
export default __webpack_public_path__ + "static/media/sub-systm.45e9ac027557abb0d12b337fb348b47f.svg";
export { ForwardRef as ReactComponent };